import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import PoliticaPrivacidade from '@/views/PoliticaPrivacidade.vue';
import PlanosPage from '@/views/PlanosPage.vue';
import QuemSomos from '@/views/QuemSomos.vue';
import CasesPage from '@/views/CasesPage.vue';
import TermosCondicacaoPage from '@/views/TermosCondicoes.vue';

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
    },
    {
        path: '/planos',
        name: 'PlanosPage',
        component:PlanosPage
    },
    {
        path: '/politicaprivacidade',
        name: 'PoliticaDePrivacidade',
        component: PoliticaPrivacidade,
    },
    {
        path: '/quemsomos',
        name: 'QuemSomos',
        component: QuemSomos,
    },
    {
        path: '/cases',
        name: 'CasesPage',
        component: CasesPage,
    }, 
    {
        path: '/termoscondicao',
        name: 'TermosCondicao',
        component: TermosCondicacaoPage
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
        return savedPosition;
        } else if (to.hash) {
        // se há hash na URL (/#funcionalidades)
        return {
            el: to.hash,
            behavior: 'smooth',
        };
        } else {
        return { top: 0 };
        }
    },
});

export default router;